// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__gkJ5z","content":"Consent_content__27aW2","footer":"Consent_footer__1eEb0"};